var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-title',{staticClass:"justify-center text-h5"},[_vm._v(" "+_vm._s(_vm.$t("pricingSettingsLabel"))+" ")]),_c('PricingTable',{attrs:{"prices":_vm.prices}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }